import React, {useState} from 'react'
import {KTSVG} from '../../../../../../../template/_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../../../redux/store'
import {setUserFilter} from '../../../../../../../redux/slices/userFilterSlice'

const UsersListSearchComponent = () => {
  const currentUserFilter = useSelector((state: RootState) => state.userFilterSlice)
  const [search, setSearch] = useState('')

  const dispatch = useDispatch()

  const handleClickFilter = () => {
    dispatch(
      setUserFilter({
        ...currentUserFilter,
        search: search,
        page: 1,
      })
    )
  }

  return (
    <div className='card-title'>
      <div className='d-flex me-6'>
        <div className='fv-row'>
          <div className='d-flex align-items-center position-relative'>
            <KTSVG
              path='/media/icons/duotune/general/gen021.svg'
              className='svg-icon-1 position-absolute ms-5 text-primary pe-4 border-1 border-end border-primary border-opacity-25'
            />
            <input
              type='text'
              data-kt-user-table-filter='search'
              className='form-control form-control-custom ps-20'
              placeholder='Buscar'
              value={search}
              onChange={(e) => {
                setSearch(e.target.value)
              }}
            />
          </div>
        </div>
      </div>
      <div className='d-flex align-items-end'>
        <button className='btn btn-primary' onClick={handleClickFilter}>
          Filtrar
        </button>
      </div>
    </div>
  )
}

export {UsersListSearchComponent}
